import { render, staticRenderFns } from "./CommunityHealthinfoCard.vue?vue&type=template&id=1ac32792&scoped=true&"
import script from "./CommunityHealthinfoCard.vue?vue&type=script&lang=js&"
export * from "./CommunityHealthinfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityHealthinfoCard.vue?vue&type=style&index=0&id=1ac32792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac32792",
  null
  
)

export default component.exports